import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewChecked, ElementRef, AfterContentChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JhiAlertService } from 'ng-jhipster';

import {AccountService, LoginService, UserService, ScrollToService, CreateAccountErrorType} from '../../shared';
import { ErrorService } from '../../shared/services/error.service';
import { EditableAccount, UpdateAccountErrorType, AccountType, NotificationType, MyInformation } from '../../shared/model/account.model';
import { isNullOrUndefined } from 'util';
import { isEmpty } from './../../shared/core/util';

@Component({
    selector: 'jhi-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, AfterContentChecked, AfterViewChecked {
    account: EditableAccount;

    retrivedInfo: MyInformation = new MyInformation();
    confirmEmail: {confirmEmail: string} = {
        confirmEmail: ''
    };

    enableScroll = false;

    isTechnicalError: boolean;
    modalReference: any;

    @ViewChild('compteForm') compteForm: NgForm;
    @ViewChild('compteForm', { read: ElementRef }) compteFormElRef: ElementRef;
    @ViewChild('credentialsChangeModal') credentialsChangeModal: any;
    @ViewChild('myInfoChangeModal') myInfoChangeModal: any;
    @ViewChild('notificationModal') notificationModal: any;

    isFCUser = false;
    isMorale = false;
    oldNotificationType: NotificationType;

    showUpgradeWarning = true;
    showSaveMsg = false;

    isLoading: boolean;
    disableAnnulerBtn = false;
    isCreateAccountBtnClicked = false;

    constructor(
        private accountService: AccountService,
        private userService: UserService,
        private loginService: LoginService,
        private modalService: NgbModal,
        private scrollToService: ScrollToService,
        private errorService: ErrorService,
        private alertService: JhiAlertService,
        private location: Location
    ) {}

    ngOnInit() {
        this.userService.getAccount().then((account) => {
            this.account = this.accountService.mapAccoutToEditableAccount(account);
            this.account.credentials.oldEmail = this.account.credentials.email;
            this.initRetrivedInfo();
            this.isFCUser = !isNullOrUndefined(this.account.credentials.franceConnectSubscription);
            this.isMorale = AccountType.MORALE === account.type;
            this.oldNotificationType = account.notification;
        });
    }

    initRetrivedInfo(): void {
        this.retrivedInfo.firstName = this.account.firstName;
        this.retrivedInfo.lastName = this.account.lastName;
        this.retrivedInfo.adresse1 = this.account.address.adresse1;
        this.retrivedInfo.adresse2 = this.account.address.adresse2;
        this.retrivedInfo.adresse3 = this.account.address.adresse3;
        this.retrivedInfo.codePostal = this.account.address.codePostal;
        this.retrivedInfo.ville = this.account.address.ville;
        this.retrivedInfo.pays = this.account.address.pays;
        this.retrivedInfo.email = this.account.credentials.email;
    }

    ngAfterContentChecked(): void {
        this.showUpgradeWarningIfNeeded();
    }


    ngAfterViewChecked(): void {
        this.scrollToFirstErrorIfNeeded();
    }

    save() {
        if (this.compteForm.valid) {
            this.enableScroll = false;
            this.compteForm.form.markAsPristine();

            if (this.isOnlyCredentialsChanged()) {
                this.openChangeCredentialModal(this.credentialsChangeModal, 'Modifier vos identifiants');
            } else if (this.isMyInfoChanged()) {
                this.openChangeMyInfoModal(this.myInfoChangeModal, 'Modifer vos informations');
            } else {
                this.saveAccount();
            }
        } else {
            this.errorService.markAllControlsAsTouched(this.compteForm);
            this.enableScroll = true;
        }
    }

    saveAccount() {
        this.accountService.save(this.account.toAccountDTO()).subscribe(() => {
            this.isLoading = false;
            this.disableAnnulerBtn = false;
            this.showSaveMsg = true;
            this.alertService.addAlert({type: 'success', msg: 'settings.messages.success', timeout: 10000}, []);
            this.isTechnicalError = false;
            if (this.isCredentialsChanged()) {
                this.loginService.logout();
                return;
            }
            this.userService.getAccount(true);
            this.location.back();
        }, (error) => {
            this.isLoading = false;
            this.disableAnnulerBtn = false;
            this.errorService.markAllControlsAsTouched(this.compteForm);
            this.processError(error ? error : {});
        });
    }

    private processError(error) {
        this.enableScroll = true;
        if (error.error.code === UpdateAccountErrorType.WRONG_OLD_PASSWORD) {
            this.compteForm.controls['oldPassword'].setErrors({ invalid: true, wrongpassword: true });
            this.errorService.markAllControlsAsTouched(this.compteForm);
        } else if (error.error.code === UpdateAccountErrorType.EMAIL_ALREADY_IN_USE) {
            this.compteForm.controls['email'].setErrors({ invalid: true, emailexists: true });
        } else if (error.error.code === CreateAccountErrorType.INVALID_NEW_PASSWORD) {
            this.compteForm.controls['password'].setErrors({ invalid: true, invalidNewPassword: true });
            this.errorService.markAllControlsAsTouched(this.compteForm);
        }else {
            this.isTechnicalError = true;
        }
    }

    onNotificationValueChange(modal) {
        if (this.account.notification === NotificationType.AUCUNE) {
            // Hack for https://github.com/ng-bootstrap/ng-bootstrap/issues/1604
            this.compteFormElRef.nativeElement.ownerDocument.activeElement.blur();
            this.modalService.open(modal, { size: 'lg' }).result.then(
                result => {
                    if (result !== 'Confirmer') {
                        this.isLoading = false;
                        this.disableAnnulerBtn = false;
                        this.account.notification = this.oldNotificationType;
                    }
                },
                _ => (this.account.notification = this.oldNotificationType)
            );
            // RGAA workaround
            const modalEl = document.querySelector('ngb-modal-window');
            modalEl.setAttribute('aria-label', 'Avertissement');
        } else {
            this.oldNotificationType = this.account.notification;
        }
    }

    openChangeCredentialModal(modal: any, message: string) {
        this.modalService.open(modal, { size: 'lg'}).result.then(
            (result) => {
                if (result === 'Confirmer') {
                    this.saveAccount();
                } else {
                    this.account.credentials.email = this.retrivedInfo.email;
                    this.confirmEmail.confirmEmail = this.retrivedInfo.email;
                    this.isLoading = false;
                    this.disableAnnulerBtn = false;
                    if (this.isMyInfoChanged()) {
                        this.compteForm.form.markAsDirty();
                    }
                }
            }
        ).catch((e) => {
            console.log('error :', e);
            this.isLoading = false;
            this.disableAnnulerBtn = false;
        });
        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', message);
    }

    openChangeMyInfoModal(modal: any, message: string) {
        this.modalReference = this.modalService.open(modal, { size: 'lg'});
        this.modalReference.result.then(
            (result) => {
                if (result === 'Confirmer') {
                    if (this.retrivedInfo.email !==
                        this.account.credentials.email) {
                            this.openChangeCredentialModal(this.credentialsChangeModal, 'Modifier vos identifiants');
                    } else {
                        this.saveAccount();
                    }
                    this.modalReference.close();
                } else {
                    this.setBackMyInfo();
                    this.isLoading = false;
                    this.disableAnnulerBtn = false;
                    this.modalReference.close();
                }
            }
        ).catch((e) => {
            console.log('error :', e);
            this.isLoading = false;
            this.disableAnnulerBtn = false;
        });
        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', message);
    }

    setBackMyInfo(): void {
        this.account.firstName = this.retrivedInfo.firstName;
        this.account.lastName = this.retrivedInfo.lastName;
        this.account.address.adresse1 = this.retrivedInfo.adresse1;
        this.account.address.adresse2 = this.retrivedInfo.adresse2;
        this.account.address.adresse3 = this.retrivedInfo.adresse3;
        this.account.address.codePostal = this.retrivedInfo.codePostal;
        this.account.address.ville = this.retrivedInfo.ville;
        this.account.address.pays = this.retrivedInfo.pays;
    }

    clickCheckAndSave(): void {
        this.clickCheck();
        this.save();
    }

    cancel() {
        this.location.back();
    }

    private isCredentialsChanged(): boolean {
        return !isEmpty(this.account.credentials.password) ||
            this.account.credentials.oldEmail !==
                this.account.credentials.email;
    }

    private isOnlyCredentialsChanged(): boolean {
        return !isEmpty(this.account.credentials.password) ||
            (this.account.credentials.oldEmail !==
            this.account.credentials.email &&
            !this.isMyInfoChanged());
    }

    private isMyInfoChanged(): boolean {
        return this.retrivedInfo.firstName !== this.account.firstName ||
        this.retrivedInfo.lastName !== this.account.lastName ||
        this.retrivedInfo.adresse1 !== this.account.address.adresse1 ||
        this.retrivedInfo.adresse2 !== this.account.address.adresse2 ||
        this.retrivedInfo.adresse3 !== this.account.address.adresse3 ||
        this.retrivedInfo.codePostal !== this.account.address.codePostal ||
        this.retrivedInfo.ville !== this.account.address.ville ||
        this.retrivedInfo.pays !== this.account.address.pays;
    }

    private showUpgradeWarningIfNeeded(): void {
        if (this.compteForm) {
            if (this.showUpgradeWarning && this.compteForm && this.compteForm.invalid) {
                this.alertService.addAlert(
                    {
                        type: 'danger',
                        msg:
                            'settings.messages.error.upgradeWarning',
                        timeout: 10000,
                        position: 'fixed'
                    },
                    []
                );
                this.errorService.markAllControlsAsTouched(this.compteForm);
                this.enableScroll = true;
            }
            this.showUpgradeWarning = false;
        }
    }

    private scrollToFirstErrorIfNeeded(): void {
        if (this.compteForm && !this.compteForm.valid && this.enableScroll) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    }

    clickCheck() {
        if (this.compteForm && !this.compteForm.valid) {
            this.isLoading = false;
            this.disableAnnulerBtn = false;
        } else {
            this.isLoading = true;
            this.disableAnnulerBtn = true;
        }
        this.isCreateAccountBtnClicked = true;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/settings/settings.component.ts